import IResult from "../../models/result/IResult";
import { sendPost, sendGet } from "./generic";
import { getBusinessManagementApiUrl } from "../../constants/Urls";
import JobberAuthenticationRequest from "../../models/integrations/api/Jobber/JobberAuthenticationRequest";
import JobberAuthenticationResponse from "../../models/integrations/api/Jobber/JobberAuthenticationResponse";
import SalesforceAuthenticationResponse from "../../models/integrations/api/Salesforce/SalesforceAuthenticationResponse";
import SalesforceAuthenticationRequest from "../../models/integrations/api/Salesforce/SalesforceAuthenticationRequest";
import ZohoCRMAuthenticationRequest from "../../models/integrations/api/Zoho/ZohoCRMAuthenticationRequest";
import ZohoCRMAuthenticationResponse from "../../models/integrations/api/Zoho/ZohoCRMAuthenticationResponse";
import ConnectedAppResponse from "../../models/integrations/api/Salesforce/ConnectedAppResponse";

export const authenticateJobber = (request: JobberAuthenticationRequest): Promise<IResult<JobberAuthenticationResponse>> => {
    return sendPost<JobberAuthenticationResponse>(`/jobber/authenticate`, request, getBusinessManagementApiUrl());
};

export const authenticateSalesforce = (request: SalesforceAuthenticationRequest): Promise<IResult<SalesforceAuthenticationResponse>> => {
    return sendPost<SalesforceAuthenticationResponse>(`/salesforce/authenticate`, request, getBusinessManagementApiUrl());
};

export const authenticateZohoCRM = (request: ZohoCRMAuthenticationRequest): Promise<IResult<ZohoCRMAuthenticationResponse>> => {
    return sendPost<ZohoCRMAuthenticationResponse>(`/zoho/authenticate`, request, getBusinessManagementApiUrl());
};

export const getSalesforceConnectedApplications = (organizationId: string, applicationIds: string[]): Promise<IResult<ConnectedAppResponse[]>> => {
    const queryParams = applicationIds
        .filter(id => id && id.trim())
        .map(id => `applicationIds=${encodeURIComponent(id)}`)
        .join('&');

    return sendGet<ConnectedAppResponse[]>(`/salesforce/ConnectedApplications/${organizationId}?${queryParams}`);
};

export const getJobberConnectedApplications = (organizationId: string, applicationIds: string[]): Promise<IResult<ConnectedAppResponse[]>> => {
    const queryParams = applicationIds
        .filter(id => id && id.trim())
        .map(id => `applicationIds=${encodeURIComponent(id)}`)
        .join('&');

    return sendGet<ConnectedAppResponse[]>(`/jobber/ConnectedApplications/${organizationId}?${queryParams}`);
};

export const getZohoConnectedApplications = (organizationId: string, applicationIds: string[]): Promise<IResult<ConnectedAppResponse[]>> => {
    const queryParams = applicationIds
        .filter(id => id && id.trim())
        .map(id => `applicationIds=${encodeURIComponent(id)}`)
        .join('&');

    return sendGet<ConnectedAppResponse[]>(`/zoho/ConnectedApplications/${organizationId}?${queryParams}`);
};


